import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient, type MerchantScopedRequest} from "../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../stem-core/state/State";
import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {Merchant} from "../MerchantStore";


@globalStore
export class MerchantEmailSender extends BaseStore("MerchantEmailSender") {
    @field("Merchant") merchant: Merchant;
    @field(String) emailAddress: string;
    @field(String) name: string;

    toString(): string {
        return this.emailAddress;
    }
}

// MerchantCreateEmailSender (api/merchants/views.py)
export interface MerchantCreateEmailSenderRequest extends MerchantScopedRequest {
    name: string;
    emailAddress: string;
}

export async function apiMerchantCreateEmailSender(request: MerchantCreateEmailSenderRequest): Promise<any> {
    return apiClient.post("merchant/create_email_sender/", request);
}

// MerchantEditEmailSender. Only the name is editable; the address is fixed once verified
export interface MerchantEditEmailSenderRequest extends MerchantScopedRequest {
    emailSenderId: StoreId;
    name: string;
}

export async function apiMerchantUpdateEmailSender(request: MerchantEditEmailSenderRequest): Promise<any> {
    return apiClient.post("merchant/update_email_sender/", request);
}

// MerchantDeleteEmailSender, the id on its own
export interface MerchantDeleteEmailSenderRequest extends MerchantScopedRequest {
    emailSenderId: StoreId;
}

export async function apiMerchantDeleteEmailSender(request: MerchantDeleteEmailSenderRequest): Promise<any> {
    return apiClient.post("merchant/delete_email_sender/", request);
}
